// istanbul ignore file

export enum SortDirection {
  Ascending = 'ascending',
  Descending = 'descending',
}
